import type { DefaultOptions } from '@tanstack/react-query'

export const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: (failureCount, error) => {
      if (error && typeof error === 'object' && 'status' in error) {
        const status = error.status as number
        if (status >= 400 && status < 500) {
          return false
        }
      }
      return failureCount < 3
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: true,
  },

  mutations: {
    retry: (failureCount, error) => {
      if (error && typeof error === 'object' && 'status' in error) {
        const status = error.status as number
        if (status >= 400 && status < 500) {
          return false
        }
      }
      return failureCount < 1
    },
  },
}

export const devQueryConfig: DefaultOptions = {
  ...queryConfig,
  queries: {
    ...queryConfig.queries,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  },
}

export const prodQueryConfig: DefaultOptions = {
  ...queryConfig,
  queries: {
    ...queryConfig.queries,
    staleTime: 5 * 60 * 1000,
  },
}

export const getQueryConfig = (): DefaultOptions => {
  if (process.env.NODE_ENV === 'development') {
    return devQueryConfig
  }
  return prodQueryConfig
}
